module.exports = __webpack_public_path__ + "static/media/wizard-box.83932cd4.png";